export const getTopLevelDomain = () => {
  const url = new URL(document.location.href);
  return url.hostname.split('.').pop();
};
export const getLocaleFromDomain = () => {
  const topLevelDomain = getTopLevelDomain();
  if (topLevelDomain === 'com') {
    return 'en';
  }
  return topLevelDomain || 'en';
};